import React, { useState } from 'react';
import { collection, addDoc } from 'firebase/firestore';
import { db } from './Firebase/firebaseConfig/firebase';
import backgroundFormContact from "../img/image_formulario_2.jpg";
import "../style/Formulario.css";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
const MySwal = withReactContent(Swal);


export default function Formulario() {

  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");
  const [email, setEmail] = useState("");
  const [telefono, setTelefono] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [isValidNombre, setIsValidNombre] = useState(true);


  // Validacion de formulario
  const handleNombreChange = (e) => {
    const inputNombre = e.target.value;
    setNombre(inputNombre);

    //Expresion regular solo letras y espacios
    const nombreRegex = /^[ a-zA-ZñÑáéíóúÁÉÍÓÚ]+$/;

    setIsValidNombre(nombreRegex.test(inputNombre))

  }

  const handleEmailChange = (e) => {
    const inputEmail = e.target.value;
    setEmail(inputEmail);

    // Expresión regular para validar el formato del correo electrónico
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    setIsValidEmail(emailRegex.test(inputEmail));
  };



  // Conexion a BD
  const contactCollection = collection(db, "Contact");

  const handleSubmit = async (e) => {


    e.preventDefault();
    if ((email === "" || telefono === "") && mensaje === "") {
      console.log("vacio");
      alertFormVacio();
    } else {
      if (isValidEmail && isValidNombre) {
        await addDoc(contactCollection, { Nombre: nombre, Apellido: apellido, Email: email, Telefono: telefono, Mensaje: mensaje });
        setNombre("");
        setApellido("");
        setEmail("");
        setTelefono("");
        setMensaje("");
        alertEnviado();

      } else {
        console.log('Fallo en formulario.');

      }
    }

  }

  const borrar = (e) => {
    setNombre("");
    setApellido("");
    setEmail("");
    setTelefono("");
    setMensaje("");
  }

  //Alert envio correcto
  const alertEnviado = () => {
    Swal.fire({
      title: 'Mensaje enviado',
      text: 'Te contactaremos a la brevedad',
      icon: "success",
      showClass: {
        popup: 'animate__animated animate__fadeInDown'
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOutUp'
      }
    });
  }

  //Alert no se puede enviar
  const alertFormVacio = () => {
    Swal.fire({
      icon: "error",
      text: "Debe completar el formulario con su email o télefono y el mensaje. Por favor, vuelva a intentarlo.",
    });
  }

  return (
    <div className='form-container'>

      <div className='background-contact-form' style={{ backgroundImage: `url(${backgroundFormContact})`, backgroundSize: 'cover', backgroundPosition: 'center' }}></div>
      <h3>Dejanos un mensaje</h3>
      <div className='form'>

        <form onSubmit={handleSubmit}>

          <div className='label-input'>
            <label className='label'>Nombre:</label>
            <input
              value={nombre}
              type="text"
              className='form-input'
              placeholder='Tu Nombre'
              onChange={handleNombreChange}

            />


          </div>

          <div className='label-input'>
            <label className='label'>Apellido:</label>
            <input
              value={apellido}
              type="text"
              className='form-input'
              placeholder='Tu Apellido'
              onChange={(e) => setApellido(e.target.value)}
            />
          </div>

          <div className='label-input'>
            <label className='label'>Telefono:</label>
            <input
              value={telefono}
              type="text"
              className='form-input'
              placeholder='Tu Teléfono'
              onChange={(e) => setTelefono(e.target.value)}
            />
          </div>

          <div className='label-input'>
            <label className='label'>Email:</label>
            <input
              value={email}
              type="text"
              className='form-input'
              placeholder='tu@email.com'
              onChange={handleEmailChange}
            />
          </div>

          <div className='label-input'>
            <label className='label'>Mensaje:</label>
            <textarea id="" cols="30" rows="4" maxLength="200"
              value={mensaje}
              type="text"
              className='form-input'
              placeholder='Hola!...'
              onChange={(e) => setMensaje(e.target.value)} >
            </textarea>

          </div>



          <div className='btn-form'>
            <button type="submit" className=''>Enviar</button>
            <button onClick={borrar} className=''>Borrar</button>
          </div>
          {!isValidEmail && <p>Por favor, ingresa un correo electrónico válido.</p>}
          {!isValidNombre && <p>Por favor, ingresa un nombre valido.</p>}

        </form>

      </div>
    </div>


  )
}


